const appTypes = {
    VISIBILITY: "VISIBILITY",
  }
  
  export default appTypes